import { Ref, UnwrapNestedRefs, Slot } from 'vue'

import { OptionContent } from './interface'
import { Trigger, DropdownSize } from '../../enums'

export const optionProvision = Symbol('d-option')
export const dropdownProvision = Symbol('d-dropdown')

export interface OptionProvision {
  id: string
}

export interface DropdownProvision {
  trigger: Ref<Trigger>
  visible: Ref<boolean>
  size: Ref<DropdownSize>
  multiple: Ref<boolean>
  revertable: Ref<boolean>
  modelValue: Ref<string | number | boolean | (string | number | boolean)[] | undefined>
  activeOptions: Ref<Record<string, OptionContent>>
  optionsDescription: UnwrapNestedRefs<Record<string, Record<string, { option: OptionContent; active: boolean; subActive: boolean }>>>
  mark: Ref<string | undefined>
  maxWidth: Ref<string | number | undefined>
  maxHeight: Ref<string | number | undefined>
  dense: Ref<boolean>
  virtualize: Ref<boolean>
  virtualizeOptions: Ref<{ optionHeight: number; optionGap: number; renderLimit: number; preCreate?: boolean }>
  optionSlot: Ref<Slot>
  optionPrefixSlot: Ref<Slot>
  optionContentSlot: Ref<Slot>
  optionSuffixSlot: Ref<Slot>
  optionVirtualize: Ref<{ virtualizeBefore: number; virtualizeAfter: number }>
}
